<template>
  <b-row>
    <b-col>

      <b-row
        v-for="item in value"
        :key="collapseId(item)"
      >
        <b-col>
          <b-row
            align-v="center"
            class="menu-permissao-linha"
          >
            <b-col
              :style="recuoPadding"
              cols="5"
            >
              <b-row align-v="center">
                <b-col
                  cols="auto"
                  class="py-50 pr-0"
                >
                  <b-button
                    v-if="item.filhos && item.filhos.length > 0"
                    v-b-toggle="collapseId(item)"
                    style="background-color: inherit !important;"
                    pill
                    variant="none"
                    class="btn-sm border-0 rounded p-50 text-secondary"
                  >
                    <feather-icon :icon="'ChevronDownIcon'" />
                  </b-button>
                  <span
                    v-else
                    class="recuo-sem-filhos"
                  />
                </b-col>
                <b-col cols="8">
                  <b-checkbox
                    v-if="!item.filhos || item.filhos.length == 0"
                    v-model="item.habilitado"
                    :disabled="admin"
                    @change="onRecursoHabilitadoChange(item)"
                  >
                    {{ item.recurso.descricao.charAt(0).toUpperCase() + item.recurso.descricao.slice(1) }}

                  </b-checkbox>
                  <span v-else>
                    <b>{{ capitalizeWords(item.recurso.descricao) }}</b>
                  </span>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="7">
              <permissoes
                v-if="!item.filhos || item.filhos.length == 0"
                v-model="item.permissao"
                :class="{ 'menu-permissao-checkboxes-inativas': !item.habilitado && !admin }"
                :admin="admin"
                :regra-recurso="item.regraRecurso"
                :portal="item.habilitado && item.regraRecurso === 'somentealteracao'"
                :sem-remocao="item.habilitado && item.regraRecurso === 'semremocao'"
                :todos-campos="item.habilitado && item.regraRecurso === 'todoscampos'"
                :painel-proposta="item.habilitado && item.regraRecurso === 'somentevisualizacao'"
                :alteracao="item.habilitado && item.regraRecurso === 'alteracao'"
                @input="onPermissaoChange(item)"
              />
            </b-col>
          </b-row>
          <b-collapse
            v-if="item.filhos && item.filhos.length > 0"
            :id="collapseId(item)"
          >
            <b-row>
              <b-col>
                <menu-permissao-item
                  v-model="item.filhos"
                  :posicao="posicao + 1"
                  :admin="admin"
                  :collapse-prefix="collapsePrefix"
                  @input="sendToParent()"
                />
              </b-col>
            </b-row>
          </b-collapse>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'MenuPermissaoItem',
  components: {
    Permissoes: () => import('./Permissao.vue'),
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    posicao: {
      type: Number,
      required: true,
    },
    admin: {
      type: Boolean,
      default: false,
    },
    collapsePrefix: {
      type: String,
      default: '',
    },
  },
  computed: {
    recuoPadding: {
      get() {
        return `padding-left:${this.posicao * 32}px;`
      },
    },
  },
  methods: {
    collapseId(item) {
      return `${this.collapsePrefix}linha-${item.moduloRecursoId}`
    },
    limparPermissaoDoRecurso(permissao) {
      if (!permissao) return
      this.$set(permissao, 'adicionar', false)
      this.$set(permissao, 'visualizar', false)
      this.$set(permissao, 'alterar', false)
      this.$set(permissao, 'remover', false)
      this.$set(permissao, 'controleTotal', false)
    },
    onRecursoHabilitadoChange(item) {
      if (!item.habilitado && item.permissao) {
        this.limparPermissaoDoRecurso(item.permissao)
      }
      this.sendToParent()
    },
    temAlgumaPermissaoMarcada(permissao) {
      if (!permissao) return false
      return !!(
        permissao.adicionar
        || permissao.visualizar
        || permissao.alterar
        || permissao.remover
        || permissao.controleTotal
      )
    },
    onPermissaoChange(item) {
      if (!item.filhos || item.filhos.length === 0) {
        const temPermissao = this.temAlgumaPermissaoMarcada(item.permissao)
        if (temPermissao && !item.habilitado) {
          this.$set(item, 'habilitado', true)
        }
        if (item.habilitado && !temPermissao) {
          this.$set(item, 'habilitado', false)
        }
      }
      this.sendToParent()
    },
    sendToParent() {
      this.$emit('input', this.value)
    },
    capitalizeWords(value) {
      if (!value) return ''
      return value
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    },
  },

}
</script>

<style lang="scss" scoped>
.menu-permissao-checkboxes-inativas {
  opacity: 0.55;
}
</style>
